import styled from '@emotion/native';
import { BodyText, H3, H2, BaseText } from '@/shared/components/StyledText';
import { green, lightGreen, subheadline, sand } from '@/shared/styles/colors';
import { IsDesktopProps } from '@/shared/styles/types';
import { DimensionValue } from 'react-native';

export const Container = styled.View<IsDesktopProps & { isInChat?: boolean }>(
  ({ isDesktop, isInChat }) => ({
    marginHorizontal: isDesktop ? 48 : 0,
    paddingTop: !isDesktop && !isInChat ? 24 : 0,
    display: 'flex',
    alignSelf: 'stretch',
    flex: 1,
    ...(!isDesktop && {
      backgroundColor: sand,
    }),
  }),
);

export const IntroContentContainer = styled.View<IsDesktopProps>(
  ({ isDesktop }) => ({
    flexDirection: 'column',
    justifyContent: isDesktop ? 'space-between' : 'center',
    alignItems: isDesktop ? 'flex-start' : 'center',
    marginBottom: isDesktop ? 28 : 24,
    width: '100%',
    maxWidth: isDesktop ? 'auto' : 330,
    marginHorizontal: 'auto',
  }),
);

export const Title = styled(H2)({
  textAlign: 'center',
  textTransform: 'uppercase',
  color: green,
});

export const ChannelListContainer = styled.View<{
  marginBottom?: DimensionValue;
}>(({ marginBottom }) => ({
  flex: 1,
  width: '100%',
  ...(marginBottom && {
    marginBottom,
  }),
}));

export const IntroText = styled(BodyText)<IsDesktopProps>(({ isDesktop }) => ({
  color: lightGreen,
  textAlign: isDesktop ? 'left' : 'center',
  maxWidth: isDesktop ? 'auto' : 240,
  fontWeight: 400,
  ...(!isDesktop && {
    fontSize: 16,
    lineHeight: 18,
  }),
}));

export const StyledH3 = styled(H3)({
  textAlign: 'center',
  textTransform: 'uppercase',
  color: green,
  marginBottom: 10,
  marginHorizontal: 40,
});

export const StyledBodyText = styled(BodyText)({
  textAlign: 'center',
  color: subheadline,
  marginBottom: 21,
  marginHorizontal: 23,
  maxWidth: 400,
});

export const ErrorContainer = styled.View({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const SupportLink = styled(BodyText)({
  color: green,
  textDecorationLine: 'underline',
  fontWeight: 500,
});

export const TabBar = styled.View<{ isDesktop: boolean }>(({ isDesktop }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
  marginBottom: 16,
  paddingLeft: isDesktop ? 12 : 16,
}));

export const Tab = styled.TouchableOpacity<{ isActive: boolean }>(
  ({ isActive }) => ({
    backgroundColor: 'transparent',
    border: 'none',
    paddingTop: 8,
    paddingBottom: 4,
    borderBottomWidth: isActive ? 3 : 0,
    borderBottomStyle: 'solid',
    borderBottomColor: isActive ? green : 'transparent',
    cursor: 'pointer',
  }),
);

export const TabText = styled(BaseText)<{ isActive: boolean }>(
  ({ isActive }) => ({
    color: green,
    fontWeight: isActive ? 700 : 400,
    fontSize: 12,
  }),
);
